import moment from 'moment';

const DEFAULT_FORMAT = 'MMM DD, YYYY HH:mm:ss Z';

const dateTime = (val, format) => moment(val).format(format || DEFAULT_FORMAT);

export default dateTime;
